import { useCreateShippingProfile, useProductsList } from "./hooks";
import React from "react";
import {
  Intent,
  Button,
  InputGroup,
  Classes,
  Dialog,
  FormGroup
} from "@blueprintjs/core";
import styles from "../ShippingSettings.module.scss";
import FormInfo from "../../../../atoms/FormInfo/FormInfo";
import { SelectList } from "../../../../molecules/SelectList";

export function CreateProfileButton() {
  const {
    isModalOpen,
    setIsModalOpen,
    onCloseDialog,
    productIds,
    setProductIds,
    searchText,
    setSearchText,
    profileName,
    setProfileName,
    onCreateShippingProfile,
    isSaving,
    isSubmitDisabled
  } = useCreateShippingProfile();

  const { productList, loading } = useProductsList(searchText, isModalOpen);

  return (
    <>
      <Dialog
        icon="cube"
        onClose={onCloseDialog}
        title="Shipping Profile"
        isOpen={isModalOpen}
        className={styles.simpleDialog}
        canOutsideClickClose={!isSaving}
        canEscapeKeyClose={!isSaving}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormInfo>
            Choose where you ship and how much you charge for shipping at
            checkout. To charge different rates for certain products, create a
            shipping profile.
          </FormInfo>
          <FormInfo>
            Learn more about <a href="#">shipping profiles</a>.
          </FormInfo>
          <FormGroup
            label="Profile Name"
            labelFor="profileName"
            helperText="Customers won't see this."
          >
            <InputGroup
              id="profileName"
              value={profileName}
              onChange={setProfileName}
              placeholder="e.g. Fragile Items"
            />
          </FormGroup>
          <FormGroup label="Products" labelFor="productSearch">
            <InputGroup
              leftIcon="search"
              type="search"
              id="productSearch"
              value={searchText}
              onChange={setSearchText}
              placeholder="Search products and variants"
            />
          </FormGroup>
          <SelectList
            data={productList}
            value={productIds}
            onChange={setProductIds}
            loading={loading}
            emptyListMessage="No products available"
          />
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Cancel"
              type="button"
              minimal="true"
              disabled={isSaving}
              onClick={onCloseDialog}
              intent={Intent.NONE}
            />
            <Button
              text="Save"
              disabled={isSubmitDisabled}
              loading={isSaving}
              onClick={onCreateShippingProfile}
              intent={Intent.PRIMARY}
            />
          </div>
        </div>
      </Dialog>
      <Button
        text="Create Profile"
        intent={Intent.PRIMARY}
        onClick={() => setIsModalOpen(true)}
      />
    </>
  );
}
